import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useEngineState } from '../club/ClubProvider.tsx'
import { Banner } from '../ui/components.tsx'
import { ProceduresTab } from './planSetup/ProceduresTab.tsx'
import { RecurrencesTab } from './planSetup/RecurrencesTab.tsx'
import { TaskTypesTab } from './planSetup/TaskTypesTab.tsx'
import { TemplatesTab } from './planSetup/TemplatesTab.tsx'

const TABS = ['types', 'procedures', 'templates', 'recurrences'] as const
type Tab = (typeof TABS)[number]

/** Planning set-up for the head greenkeeper: task types, procedures, job templates and recurrences. Reading works from the device's own copy; every write is an
 *  online command and the screen shows the server's verdict (see data/planSetup.ts for the checks that are mirrored here). */
export function PlanSetupPage() {
  const { t } = useTranslation()
  const [tab, setTab] = useState<Tab>('types')
  const online = useEngineState().online !== false
  return (
    <section className="flex flex-col gap-4" data-testid="plan-setup-page">
      <h1 className="text-2xl font-bold">{t('planSetup.title')}</h1>
      <p className="text-sm opacity-75">{t('planSetup.help')}</p>
      {!online && <Banner tone="warn"><span data-testid="setup-offline">{t('planSetup.offline')}</span></Banner>}
      <div role="tablist" aria-label={t('planSetup.title')} className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {TABS.map((id) => (
          <button key={id} role="tab" id={`setup-tab-${id}`} aria-selected={tab === id} aria-controls={`setup-panel-${id}`} tabIndex={tab === id ? 0 : -1} data-testid={`setup-tab-${id}`} onClick={() => setTab(id)}
            className={`btn !min-h-12 !px-2 text-sm ${tab === id ? 'btn-primary' : ''}`}>
            {t(`planSetup.tabs.${id}`)}
          </button>
        ))}
      </div>
      <div role="tabpanel" id={`setup-panel-${tab}`} aria-labelledby={`setup-tab-${tab}`} data-testid={`setup-panel-${tab}`}>
        {tab === 'types' && <TaskTypesTab />}
        {tab === 'procedures' && <ProceduresTab />}
        {tab === 'templates' && <TemplatesTab />}
        {tab === 'recurrences' && <RecurrencesTab />}
      </div>
    </section>
  )
}
